import comp from "./CommentBox";
export default comp;
